import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { isPricingLive } from "@/config/pricing";

export default function PaywallGate({ children }) {
  const { user, loading } = useAuth();

  // Still loading auth — show nothing
  if (loading)
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-6 h-6 border-2 border-[var(--ind)] border-t-transparent rounded-full animate-spin" />
      </div>
    );

  // Free period — everyone gets in
  if (!isPricingLive()) return children;

  // Paywall is live — check if paid
  if (user?.is_paid) return children;

  // Not paid — save intended route and redirect
  if (typeof window !== "undefined") {
    sessionStorage.setItem("intendedRoute", window.location.pathname);
  }
  return <Navigate to="/pricing" replace />;
}
